import type { ReactNode } from 'react';
import { Pill } from 'lucide-react';

import { cn } from '@/lib/cn';

export interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  /** Link row under the card, e.g. "Already have an account?". */
  footer?: ReactNode;
}

/** Centred card for the signed-out screens. Nothing here reads any session. */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: AuthLayoutProps): JSX.Element {
  return (
    <div
      className={cn(
        'flex min-h-dvh flex-col items-center justify-center bg-canvas px-4',
        'pad-safe-top pad-safe-bottom pad-safe-x',
      )}
    >
      <div className="w-full max-w-sm">
        <div className="mb-6 flex flex-col items-center gap-3 text-center">
          <span className="flex size-12 items-center justify-center rounded-2xl bg-accent/10 text-accent">
            <Pill className="size-6" aria-hidden="true" />
          </span>
          <div className="space-y-1">
            <h1 className="text-xl font-semibold tracking-tight text-ink">{title}</h1>
            {subtitle ? <p className="text-sm text-muted">{subtitle}</p> : null}
          </div>
        </div>

        <div className="rounded-card border border-line bg-surface p-5 shadow-card">
          {children}
        </div>

        {footer ? (
          <div className="mt-4 text-center text-sm text-muted">{footer}</div>
        ) : null}
      </div>
    </div>
  );
}
